import * as React from 'react';

import { IAssertionDescriptorValueModel } from '../../interfaces/IAssertionDescriptor';
import { IValidation } from '../../interfaces/IError';
import { Modal } from 'react-bootstrap';
import { cloneDeep } from 'lodash';

interface IAssertionDescriptorValueModalProps {
    displayDialog: boolean;
    existingADValues: IAssertionDescriptorValueModel[];
    onAssertionDescriptorValueModalClose: () => void;
    onAssertionDescriptorValueModalConfirm: (
        assertionDescriptorValue: IAssertionDescriptorValueModel
    ) => void;
    assertionDescriptorValue: IAssertionDescriptorValueModel;
}

interface IAssertionDescriptorValueModalState {
    assertionDescriptorValue: IAssertionDescriptorValueModel;
    validation: IValidation;
}

export class AssertionDescriptorValueModal extends React.Component<
    IAssertionDescriptorValueModalProps,
    IAssertionDescriptorValueModalState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            assertionDescriptorValue: this.props.assertionDescriptorValue,
            validation: {},
        };
    }

    changeValue = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const name = event.target.name;
        const value = event.target.value;

        const assertionDescriptorValue = cloneDeep(this.state.assertionDescriptorValue);
        const validation = cloneDeep(this.state.validation);

        if (assertionDescriptorValue) {
            switch (name) {
                case 'text':
                    assertionDescriptorValue.text = value;
                    validation.text = [''];
                    break;
                case 'numericValue':
                    assertionDescriptorValue.numericValue = parseFloat(value);
                    validation.numericvalue = [''];
                    break;
                case 'sortOrder':
                    assertionDescriptorValue.sortOrder = parseInt(value);
                    validation.numericvalue = [''];
                    break;
                default:
                    break;
            }
            this.setState({
                assertionDescriptorValue: assertionDescriptorValue,
                validation: validation,
            });
        }
    };

    handleAssertionDescriptorValueModalConfirm = () => {
        if ((this.state.assertionDescriptorValue.text?.length ?? 0) === 0) {
            const validation = this.state.validation;
            validation.text = ['This is a required field'];
            this.setState({
                validation: validation,
            });
            return;
        }

        if (
            this.props.assertionDescriptorValue.text?.toLowerCase() !==
                this.state.assertionDescriptorValue.text?.toLowerCase() &&
            this.props.existingADValues?.some(
                (adv) =>
                    adv.text?.toLowerCase() ===
                    this.state.assertionDescriptorValue.text?.toLowerCase()
            )
        ) {
            const validation = this.state.validation;
            validation.text = ['Text fields must be unique across items'];
            this.setState({
                validation: validation,
            });
            return;
        }

        this.props.onAssertionDescriptorValueModalConfirm(this.state.assertionDescriptorValue);
    };

    render() {
        return (
            <Modal
                centered
                show={this.props.displayDialog}
                onHide={this.props.onAssertionDescriptorValueModalClose}
                backdrop={false}
            >
                <Modal.Header>
                    <Modal.Title>
                        {this.props.assertionDescriptorValue ? 'Add' : 'Update'} - Value
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-2">
                        <div className="col-sm-4">
                            <label className="control-label" htmlFor="text">
                                Text*
                            </label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                type="text"
                                name="text"
                                className="form-control col-sm-8"
                                value={this.state.assertionDescriptorValue.text || ''}
                                onChange={this.changeValue}
                            />
                        </div>
                        {this.state.validation.text && (
                            <div className="offset-sm-4 col-sm-8 text-danger">
                                {this.state.validation.text}
                            </div>
                        )}
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-4">
                            <label className="control-label" htmlFor="numericValue">
                                Numeric Value
                            </label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                type="number"
                                pattern="^\d+(?:\.\d{1,2})?$"
                                name="numericValue"
                                className="form-control"
                                value={this.state.assertionDescriptorValue.numericValue || ''}
                                onChange={this.changeValue}
                            />
                        </div>
                        {this.state.validation.numericvalue && (
                            <div className="offset-sm-4 col-sm-8 text-danger">
                                {this.state.validation.numericvalue}
                            </div>
                        )}
                    </div>
                    <div className="row mb-2">
                        <div className="col-sm-4">
                            <label className="control-label" htmlFor="sortOrder">
                                Sort Order
                            </label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                type="number"
                                pattern="^\d+(?:\d{1,2})?$"
                                name="sortOrder"
                                className="form-control"
                                value={this.state.assertionDescriptorValue.sortOrder || ''}
                                onChange={this.changeValue}
                            />
                        </div>
                        {this.state.validation.sortOrder && (
                            <div className="offset-sm-4 col-sm-8 text-danger">
                                {this.state.validation.sortOrder}
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-orange"
                        onClick={this.handleAssertionDescriptorValueModalConfirm}
                    >
                        Save
                    </button>
                    <button
                        className="btn btn-default"
                        onClick={this.props.onAssertionDescriptorValueModalClose}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
